<template>
  <v-autocomplete
    ref="controlFocoSelectArticulo"
    :label="iLabel"
    v-model="itemActivo.Id_Articulo"
    :items="items"
    item-value="Id_Articulo"
    item-text="NombreCodigoBarras"
    :rules="rules"
    :readonly="readonly"
    :search-input.sync="palabraBuscada"
    :loading="loading"
    outlined
    hide-details
    clearable
    auto-select-first
    @change="buscar"
    @keyup.enter="listar"
    @click:clear="inicializar"
    @click:append="listar"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>{{ item.NombreCodigoBarras }}</v-list-item-content>
      <v-list-item-action>
        <strong>{{ item.Contado | esMoneda }}</strong>
      </v-list-item-action>
    </template>
    <template v-slot:no-data>
      <v-icon small>info</v-icon>
      <small>
        Ingrese el texto a buscar y presione
        <strong>ENTER</strong>
      </small>
    </template>
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-autocomplete>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectArticulo",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      itemVacio: {
        Id_Articulo: 0
      },
      itemActivo: {},
      items: [],
      palabraBuscada: "",
      loading: false
    };
  },
  computed: {
    iLabel() {
      return this.rules == null ? "Artículo" : "Artículo*";
    }
  },
  watch: {
    model(valor) {
      if (valor && valor != this.itemActivo.Id_Articulo) this.cargar(valor);
    }
  },
  created() {
    eventBus.$on("inicializarSelectArticulo", this.inicializar);
    eventBus.$on("setearFocoSelectArticulo", this.setearFoco);
  },
  beforeDestroy() {
    eventBus.$off("inicializarSelectArticulo", this.inicializar);
    eventBus.$off("setearFocoSelectArticulo", this.setearFoco);
  },
  methods: {
    inicializar() {
      this.loading = true;
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.items = [];
      this.palabraBuscada = "";
      this.loading = false;
    },
    cargar(valor) {
      if (valor) {
        this.loading = true;
        this.items = [];
        HttpHelper.get("Articulo", {
          id: valor
        })
          .then(response => {
            this.items.push(response.data);
            this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    listar() {
      if (this.palabraBuscada && this.palabraBuscada.length > 0) {
        this.loading = true;
        HttpHelper.get("Articulo/ListarSelect", {
          palabra: this.palabraBuscada
        })
          .then(response => {
            this.items = response.data;
            if (this.items.length == 1) this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    buscar(id) {
      if (id) {
        var ind = this.items.findIndex(x => x.Id_Articulo == id);
        this.seleccionarItem(this.items[ind]);
      } else this.seleccionarItem(this.itemVacio);
    },
    seleccionarItem(item) {
      this.itemActivo = item;
      this.$emit("seleccionarItem", this.itemActivo);
    },
    setearFoco() {
      this.$refs.controlFocoSelectArticulo.focus();
    }
  }
};
</script>
